let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dTnVI")).then(() => parcelRequire('iba0t'));